<div class="row" style="width: 100%; margin: 0px" *ngIf="ActivityProgressData">
    <div class="col-md-4">
        <app-activity-progress-report-chart
            [CustomColors]="activityPackCustomColors"
            [data]="totalWorkpacks"
            *ngIf="totalWorkpacks?.length"
            [Alldata]="ActivityProgressData?.activityPack"
            [title]="title1"
            [isChartShow]="isWorkpacksTotal"
        ></app-activity-progress-report-chart>
    </div>
    <div class="col-md-4">
        <app-activity-progress-report-chart
            [CustomColors]="activityPackTaggedItemCustomColors"
            [data]="totalactivityPackTaggedItem"
            *ngIf="totalactivityPackTaggedItem?.length"
            [Alldata]="ActivityProgressData?.activityPackTaggedItem"
            [title]="title2"
            [isChartShow]="isactivityPackTaggedItemTotal"
        ></app-activity-progress-report-chart>
    </div>
    <div class="col-md-4" *ngIf="activityPackTaggedItemActivity">
        <div class="row">
            <div class="col-md-12">
                <div class="card_gridTwo">
                    <div class="project_title">
                        <h3>{{ 'IDMS.REPORTS.JOINT_METRICS' | transloco }}</h3>
                        <hr style="margin-top: 0px" />
                    </div>

                    <div class="card_gridFour" style="box-shadow: none; margin-top: -12px">
                        <div class="row table-wrapper" *ngFor="let group of activityPackTaggedItemActivity | keyvalue" style="margin-bottom: 11px">
                            <h4>{{ group.key }}</h4>
                            <div class="col-md-12">
                                <div class="row" *ngFor="let j of group.value | keyvalue: orderComparator">
                                    <ng-container>
                                        <div class="col-md-4 px-0">
                                            <div class="item-content" [class.bold]="j.value.key == 'Total'">
                                                <span>{{ j.value.key }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-4 px-0">
                                            <div class="item-content" [class.bold]="j.value.key == 'Total'">
                                                <span>{{ j.value.value }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-4 px-0">
                                            <div class="item-content last">
                                                <span>{{ j.value.percentage | percentage }}</span>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                            <br />
                        </div>
                        <!-- </ng-container>  -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
